<template>
  <div class="header">
    <div class="nav-wrapper">
      <div class="nav-content">
        <div class="nav-left">
          <router-link to="/">爱温泉 爱生活</router-link>
        </div>
        <div class="nav-center">
           <!-- <router-link to="/login"
            class="red-txt"
          >亲，请登录</router-link> -->
        </div>
        <div class="nav-right">
          <a ><i
              class="fa fa-phone"
              aria-hidden="true"
            ></i>&nbsp;全国预定热线：0756-5797128</a>
        
          <!-- <a
            href="javascript:void(0)"
          >我的订单</a> -->
          &nbsp;&nbsp;/&nbsp;&nbsp;
          <a
            class="red-txt"
            href="http://www.00800.com.cn/cnhs/wqproject/index.php?app=public&mod=index&act=index"
          >
            <i
              class="fa fa-mobile"
              aria-hidden="true"
            ></i>&nbsp;手机御温泉
          </a>
          &nbsp;&nbsp;/&nbsp;&nbsp;
          <router-link to="/other/contact">联系我们</router-link>
          &nbsp;&nbsp;/&nbsp;&nbsp;
          <router-link to="/other/traffic">交通指南</router-link>
          &nbsp;&nbsp;/&nbsp;&nbsp;
          <router-link to="/other/about">关于御温泉</router-link>
          &nbsp;&nbsp;/&nbsp;&nbsp;
          <a href="http://www.00800.com.cn/cnhs/wqproject/index.php?app=public&mod=PCNew&act=index">旧版入口&nbsp;<span class="icon-down"></span></a>
          &nbsp;&nbsp;/&nbsp;&nbsp;
          <a href="http://www.ywqinfoplatform.com/">御温泉服务标准示范区&nbsp;<span class="icon-down"></span></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.header {
  width: 100vw;
  .nav-wrapper {
    height: 40px;
    line-height: 40px;
    border-top: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
    font-size: 12px;
    background: #eaeaea;
    .nav-content {
      width: 1140px;
      margin: 0 auto;
      color: #d0cfcf;
      display: flex;
      justify-content: space-around;
      .red-txt {
        color: #ff3d3d;
      }
    }
    
  }
}
</style>
